import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const Container = styled(Box)({
  width: '100%',
  maxWidth: '540px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  textAlign: 'center',
});

export const TabItem = styled(Typography)({
  fontWeight: 400,
  fontSize: 'clamp(14px, 3.9vw, 17px)',
  width: '100%',
});
